import { create } from 'zustand';
import { createJSONStorage, persist, type StateStorage } from 'zustand/middleware';

interface OrgStore {
  currentOrganizationId: string | null;
  setCurrentOrganizationId: (id: string | null) => void;
}

const ORG_STORAGE_KEY = 'current_organization_id';

const noopStorage: StateStorage = {
  getItem: () => null,
  setItem: () => undefined,
  removeItem: () => undefined,
};

const orgStorage: StateStorage = {
  getItem: (name) => {
    if (typeof window === 'undefined') return null;
    const value = localStorage.getItem(name);
    if (!value) return null;

    try {
      JSON.parse(value);
      return value;
    } catch {
      return JSON.stringify({
        state: { currentOrganizationId: value },
        version: 0,
      });
    }
  },
  setItem: (name, value) => {
    if (typeof window === 'undefined') return;
    localStorage.setItem(name, value);
  },
  removeItem: (name) => {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(name);
  },
};

export const useOrgStore = create<OrgStore>()(
  persist(
    (set) => ({
      currentOrganizationId: null,
      setCurrentOrganizationId: (id) => set({ currentOrganizationId: id }),
    }),
    {
      name: ORG_STORAGE_KEY,
      storage: createJSONStorage(() =>
        typeof window === 'undefined' ? noopStorage : orgStorage,
      ),
    },
  ),
);
